module.exports = {
    tag: 'health',
    quality: 0.4,
    toughness: 2,
    regeneration: 0.8
};